angular.module('iw.frontyard.app', [])
    .constant('FRONTYARD_ROOT_URL', window.STATIC_URL);